import type { CalendarConnection, ExternalCalendarContext, ExternalCalendarEvent } from "../../domain/app-types.ts";
import type { WeekStart } from "../tasks/calendar-presentation.ts";

export type CalendarMode = "day" | "week" | "month";

export interface CalendarStatePreferences {
  mode: CalendarMode;
  weekStart: WeekStart;
  weekNumbers: boolean;
  recurrenceProjections: boolean;
  contextEnabled: boolean;
  anchor: string;
}

export class CalendarState {
  mode: CalendarMode;
  weekStart: WeekStart;
  weekNumbers: boolean;
  recurrenceProjections: boolean;
  contextEnabled: boolean;
  anchor: string;
  schedulingTaskId: string | null = null;
  connections: CalendarConnection[] = [];
  externalEvents: ExternalCalendarEvent[] = [];
  externalErrors: ExternalCalendarContext["errors"] = [];
  contextLoading = false;

  constructor(preferences: CalendarStatePreferences) {
    this.mode = preferences.mode;
    this.weekStart = preferences.weekStart;
    this.weekNumbers = preferences.weekNumbers;
    this.recurrenceProjections = preferences.recurrenceProjections;
    this.contextEnabled = preferences.contextEnabled;
    this.anchor = preferences.anchor;
  }

  moveAnchor(direction: number, today: string, addDays: (value: string, days: number) => string, addMonths: (value: string, months: number) => string): void {
    this.anchor = direction === 0
      ? today
      : this.mode === "month"
        ? addMonths(this.anchor, direction)
        : addDays(this.anchor, this.mode === "week" ? direction * 7 : direction);
  }

  setExternalContext(state: { events: ExternalCalendarEvent[]; errors: ExternalCalendarContext["errors"]; loading: boolean }): void {
    this.externalEvents = state.events;
    this.externalErrors = state.errors;
    this.contextLoading = state.loading;
  }
}
